import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { adminApi } from "../../lib/api";
import { useAuth } from "../../lib/AuthContext";
import { Button } from "../../components/ui/button";
import { toast } from "sonner";

export default function AdminLogin() {
  const nav = useNavigate();
  const { fetchAdmin } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const r = await adminApi.post("/auth/admin/login", { email, password });
      localStorage.setItem("admin_token", r.data.access_token);
      await fetchAdmin();
      toast.success("Welcome back, Admin.");
      nav("/admin/dashboard");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 grid-bg">
      <form
        onSubmit={submit}
        className="w-full max-w-md border border-[#E5E1D8] bg-[#FFFFFF] p-8"
        data-testid="admin-login-form"
      >
        <div className="brand-tag mb-2">[ ADMIN / SECURE ]</div>
        <h2 className="font-display text-4xl uppercase tracking-tight">Control Room</h2>
        <p className="mt-2 text-[#6E6E6E] text-sm">Authorized personnel only.</p>

        <div className="mt-8 space-y-5">
          <div>
            <label className="font-mono-ds text-[10px] uppercase tracking-[0.3em] text-[#6E6E6E]">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="mt-1 w-full bg-transparent border border-[#E5E1D8] px-4 py-3 font-mono-ds text-sm focus:border-[#FF6A00] outline-none"
              data-testid="admin-email-input"
            />
          </div>
          <div>
            <label className="font-mono-ds text-[10px] uppercase tracking-[0.3em] text-[#6E6E6E]">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="mt-1 w-full bg-transparent border border-[#E5E1D8] px-4 py-3 font-mono-ds text-sm focus:border-[#FF6A00] outline-none"
              data-testid="admin-password-input"
            />
          </div>
        </div>

        <Button
          type="submit"
          disabled={submitting}
          className="mt-8 w-full rounded-2xl bg-[#FF6A00] hover:bg-[#FFFFFF] hover:text-[#161616] text-[#161616] font-mono-ds uppercase tracking-widest h-12"
          data-testid="admin-login-submit"
        >
          {submitting ? "Authenticating..." : "Enter Console →"}
        </Button>

        <Link to="/" className="mt-6 block text-center font-mono-ds text-xs uppercase tracking-[0.3em] text-[#6E6E6E] hover:text-[#FF6A00]">
          ← Back to Public Site
        </Link>
      </form>
    </div>
  );
}
